export class Dialog {
  header: string;
  subHeader: string;
  button: string;
  buttonCancel: string;
}
